import { LazyLoad } from '@petconsole/pure-fe-mui';

const VanBuilderAdmin = LazyLoad(() => import('./VanBuilderAdmin'));

export { VanBuilderAdmin };
